export default __webpack_public_path__ + "static/media/filtericon.402ad053.svg";